import { 
    GET_SAVED_NEWS, 
    GET_SAVED_NEWS_SUCCEEDED, 
    GET_FAVORITE_CINEMAS,
    GET_FAVORITE_CINEMAS_SUCCEEDED, 
    GET_YOUR_RETINGS,
    GET_YOUR_RETINGS_SUCCEEDED,
    GET_FAVORITE_MOVIES,
    GET_FAVORITE_MOVIES_SUCCEEDED,
    GET_UNVIEWED_NOTIFICATION_COUNT,
    GET_UNVIEWED_NOTIFICATION_COUNT_SUCCEEDED,
    GET_USER_DETAILS,
    GET_USER_DETAILS_SUCCEEDED,
    GET_NOTIFICATION_LIST,
    GET_NOTIFICATION_LIST_SUCCEEDED,
    READ_NOTIFICATION,
    DELETE_NOTIFICATION,
    REMOVE_PROFILE_NEWS_FROM_FAVORITE,
    REMOVE_CINEMA_FROM_FAVORITE,
    GET_FAVORITE_MOVIES_SEE_MORE_SUCCEEDED,
    GET_FAVORITE_MOVIES_SEE_MORE,
    GET_FAVORITE_CINEMAS_SEE_MORE,
    GET_FAVORITE_CINEMAS_SEE_MORE_SUCCEEDED,
    GET_SAVED_NEWS_SEE_MORE_SUCCEEDED,
    GET_SAVED_NEWS_SEE_MORE,
    REMOVE_PROFILE_MOVIE_FROM_FAVORITE,
    STORE_FACEBOOK_OR_GOOGLE_RESPONSE,
    STORE_FACEBOOK_OR_GOOGLE_RESPONSE_SUCCEEDED
} from "./types";


export const getSavedNews = (payload) => ({
    refresh: true,
    type: GET_SAVED_NEWS,
    payload,
})

export const getSavedNewsSucceeded = (payload) => ({
    type: GET_SAVED_NEWS_SUCCEEDED,
    payload,
})

export const getSavedNewsSeeMore = (payload) => ({
    refresh: true,
    type: GET_SAVED_NEWS_SEE_MORE,
    payload
})

export const getSavedNewsSeeMoreSucceeded = (payload) =>({
    type: GET_SAVED_NEWS_SEE_MORE_SUCCEEDED,
    payload
})

export const getFavoriteCinemas = (payload) => ({
    refresh: true,
    type: GET_FAVORITE_CINEMAS,
    payload,
})

export const getFavoriteCinemasSucceeded = (payload) => ({
    type: GET_FAVORITE_CINEMAS_SUCCEEDED,
    payload,
})

export const getFavoriteCinemasSeeMore = (payload) => ({
    refresh: true,
    type: GET_FAVORITE_CINEMAS_SEE_MORE,
    payload,
})

export const getFavoriteCinemasSeeMoreSucceeded = (payload) => ({
    type: GET_FAVORITE_CINEMAS_SEE_MORE_SUCCEEDED,
    payload,
})

export const getYourRatings = (payload) => ({
    refresh: true,
    type: GET_YOUR_RETINGS,
    payload
})

export const getYourRatingsSucceeded = (payload) => ({
    type: GET_YOUR_RETINGS_SUCCEEDED,
    payload
})

export const getFavoriteMovies = (payload) => ({
    refresh: true,
    type: GET_FAVORITE_MOVIES,
    payload
})

export const getFavoriteMoviesSucceeded = (payload) => ({
    type: GET_FAVORITE_MOVIES_SUCCEEDED,
    payload
})

export const getFavoriteMoviesSeeMore = (payload) => ({
    refresh: true,
    type: GET_FAVORITE_MOVIES_SEE_MORE,
    payload
})

export const getFavoriteMoviesSeeMoreSucceeded = (payload) => ({
    type: GET_FAVORITE_MOVIES_SEE_MORE_SUCCEEDED,
    payload
})

export const getUnviewedNotificationsCount = (payload) => ({
    refresh: true,
    type: GET_UNVIEWED_NOTIFICATION_COUNT,
    payload
})

export const getUnviewedNotificationsCountSucceeded = (payload) => ({
    type: GET_UNVIEWED_NOTIFICATION_COUNT_SUCCEEDED,
    payload
})

export const getUserDetails = (payload) => ({
    refresh: true,
    type: GET_USER_DETAILS,
    payload
})

export const getUserDetailsSucceeded = (payload) => ({
    type: GET_USER_DETAILS_SUCCEEDED,
    payload
})

export const getNotificationList = (payload) => ({
    refresh: true,
    type: GET_NOTIFICATION_LIST,
    payload
})

export const getNotificationListSucceeded = (payload) => ({
    type: GET_NOTIFICATION_LIST_SUCCEEDED,
    payload
})

export const readNotification = (payload) => ({
    refresh: true,
    type: READ_NOTIFICATION,
    payload
})

export const deleteNotification = (payload) => ({
    refresh: true,
    type: DELETE_NOTIFICATION,
    payload
})

export const removeMovieFromFavorite = (payload) => ({
    refresh: true,
    type: REMOVE_PROFILE_MOVIE_FROM_FAVORITE,
    payload
})

export const  removeNewsFromFavorite = (payload) => ({
    refresh: true,
    type: REMOVE_PROFILE_NEWS_FROM_FAVORITE,
    payload
})

export const removeCinemaFromFavorite = (payload) => ({
    refresh: true,
    type: REMOVE_CINEMA_FROM_FAVORITE,
    payload
})

export const storeFacebookOrGoogleResponse = (payload) => ({
    type: STORE_FACEBOOK_OR_GOOGLE_RESPONSE,
    payload
})

export const storeFacebookOrGoogleResponseSucceeded = (payload) => ({
    type: STORE_FACEBOOK_OR_GOOGLE_RESPONSE_SUCCEEDED,
    payload
})


// WEBPACK FOOTER //
// ./src/SHARED/actions/profile.actions.js